import React from 'react';
import { useNavigate } from 'react-router-dom';
import './projectCard.css';

const ProjectCard = ({ title, description, coverPhoto, pageId }) => {
  const navigate = useNavigate();

  const handleProjectClick = () => {
    navigate(`/portfolio/${pageId}`);
  };

  return (
    <div className="project-card" onClick={handleProjectClick}>
      <img className="project-image" src={coverPhoto} alt={title} />
      <div className="project-info">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ProjectCard;
